<template>
  <div class="feed-list content-box">
    <h3>{{title}}</h3>
    <p v-if="description">{{description}}</p>
    <div class="feed-list-items margin-top-2">
      <template v-if="listType === 'latest-accounts'" >
        <div class="account-item" v-for="item in items" :key="item.uniqueId">
          <!-- <a :href="item.url" target="_blank"></a> -->
          <router-link :to="{ name: 'companyStory', params: { id: item.mainEntity.id, storyTitle: item.slugTitle, storyId: item.uniqueId } }"><span class="filetype pdf">PDF</span>{{item.mainEntity.name}}</router-link>
        </div>
      </template>
      <template v-if="listType === 'latest-news'" >
        <div class="news-item" v-for="item in items" :key="item.uniqueId">
          <div class="time text-semimuted">{{item.time | date('%d-%m-%Y')}}</div><router-link :to="{ name: 'companyStory', params: { id: item.mainEntity.id, storyTitle: item.slugTitle, storyId: item.uniqueId } }" v-html="item.prettyHeadline"></router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Story } from '@/assets/js/helpers.js'
export default {
  name: 'feedList',
  props: {
    'listType': {
      type: String,
      required: true
    },
    'count': {
      type: Number,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    list: function () {
      return this.$store.state.lists[this.listConfig.saveAs] || { news: { items: [] } }
    },
    items: function () {
      return this.count ? this.list.news.items.slice(0, this.count) : this.list.news.items
    },
    title: function () {
      switch (this.listType) {
        case 'latest-news': return 'Seneste nyheder'
        case 'latest-accounts': return 'Seneste regnskaber'
      }
    },
    listConfig: function () {
      switch (this.listType) {
        case 'latest-news': return { name: 'forsiden', saveAs: 'forsiden-latest', orderBy: 'publishtime' }
        case 'latest-accounts': return { name: 'forsiden', saveAs: 'forsiden-accounts', types: [26], orderBy: 'publishtime' }
      }
    },
    description: function () {
      return false
    }
  },
  components: {
  },
  mounted: function () {
    this.$store.dispatch('loadList', { listName: this.listConfig.name, saveAs: this.listConfig.saveAs, more: false, count: this.count, types: this.listConfig.types, orderBy: this.listConfig.orderBy })
  }
}
</script>

<style lang="less" scoped>
  .feed-list {
    padding: 30px;

    h3 {
      color: #212121;
      font-size: 22px;
      line-height: 1.15;
      font-weight: 500;
      margin: 0;
    }

    .account-item, .news-item {
      margin-top: 4px;
    }

    .time {
      font-size: 14px;
      line-height: 28px;
      display: inline-block;
      margin-right: 15px;
    }
  }
</style>
